import { SubmitHandler } from "react-hook-form";
import { NotifyNotificationsForm, NotifyNotificationsFormData } from "../../../components/NotifyNotificationsForm";
import { NotifyNotificationsPreview } from "../../../components/NotifyNotificationsPreview";
import { useContentHeight } from "../../../hooks/useContentHeight";
import { NotifyNotificationEstimatedReach } from "../../../components/NotifyNotificationEstimatedReach";

export function NotifyNotificationsEdit({
  onContinue,
  onSaveDraft,
  isSaveDraftLoading = false,
  addMediaFile,
  topBarRef,
}: {
  onContinue: () => void;
  onSaveDraft: SubmitHandler<NotifyNotificationsFormData>;
  isSaveDraftLoading?: boolean;
  addMediaFile: (uuid: string) => void;
  topBarRef: React.RefObject<HTMLDivElement>;
}) {
  const topBarHeight = useContentHeight(topBarRef, {
    defaultFudge: 24.5,
  });

  return (
    <div className='tw-relative tw-m-gg-3 tw-mt-7 tw-flex tw-gap-3 sm:tw-m-7'>
      <div className='tw-w-full tw-max-w-full lg:tw-max-w-[380px] xl:tw-max-w-[500px] 2xl:tw-max-w-[700px]'>
        <NotifyNotificationsForm
          onContinue={onContinue}
          onSaveDraft={onSaveDraft}
          isSaveDraftLoading={isSaveDraftLoading}
          addMediaFile={addMediaFile}
        />
      </div>
      <div className='tw-sticky tw-z-40 tw-hidden tw-h-full tw-w-full lg:tw-block' style={{ top: topBarHeight }}>
        <div
          className='tw-flex tw-flex-col tw-gap-gg-3'
          style={{
            height: `calc(100vh - ${topBarHeight}px - 24.5px)`,
          }}
        >
          <NotifyNotificationsPreview height='100%' />
          <NotifyNotificationEstimatedReach />
        </div>
      </div>
    </div>
  );
}
